import { render, staticRenderFns } from "./produtor_rural.vue?vue&type=template&id=1f8154a2&"
import script from "./produtor_rural.vue?vue&type=script&lang=js&"
export * from "./produtor_rural.vue?vue&type=script&lang=js&"
import style0 from "./produtor_rural.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports